import { Controller } from '@hotwired/stimulus';

export default class ApexChartsPerformanceController extends Controller {
  static targets = ['chart'];
  static values = {
    seriesData: Array,
    seriesNames: Array,
    yaxisTitle: String,
    colors: { type: Array, default: ['#00E396', '#CED4DC', '#f4b940'] },
    hiddenSeries: Array,
  };

  connect() {
    // Build series from data
    const series = this.seriesDataValue.map((data, index) => {
      const seriesObj = { data };
      if (this.seriesNamesValue && this.seriesNamesValue[index]) {
        seriesObj.name = this.seriesNamesValue[index];
      }
      return seriesObj;
    });

    const minWidth = 105;

    const options = {
      chart: {
        id: 'performance',
        group: 'charts',
        type: 'line',
        height: 240,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        animations: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        row: {
          colors: ['transparent', 'transparent'],
          opacity: 0.2,
        },
        borderColor: '#f1f3fa',
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: 'MMM',
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        x: {
          formatter: function (n) {
            let d = new Date(n);
            return new Date(
              d.getFullYear(),
              d.getMonth(),
              d.getDate(),
            ).toLocaleDateString(document.documentElement.lang);
          },
        },
      },
      markers: {
        size: 2,
        strokeWidth: 2,
      },
      series: series,
      colors: this.colorsValue,
      stroke: {
        width: 2,
        curve: 'smooth',
      },
      yaxis: {
        forceNiceScale: true,
        labels: {
          minWidth: minWidth,
          formatter: function (val) {
            return (val * 100).toFixed(2) + '%';
          },
        },
        title: {
          text: this.yaxisTitleValue,
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
      },
      annotations: {
        yaxis: [
          {
            y: 0,
            borderColor: '#98a6ad',
            label: {
              borderColor: '#CED4DC',
              style: {
                color: '#000',
                background: '#CED4DC',
              },
              text: '0.00%',
              position: 'right',
            },
          },
        ],
      },
    };

    this.chart = new ApexCharts(this.chartTarget, options);
    this.chart.render().then(() => {
      if (this.hasHiddenSeriesValue) {
        this.hiddenSeriesValue.forEach((seriesName) => {
          this.chart.toggleSeries(seriesName);
        });
      }
    });
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
